export default __webpack_public_path__ + "48595450e52968c8f8c60cb49b568d38.png";